import { toast } from "sonner";
import { Eye } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

export const SharePreview = ({ study, onChange }) => {
  if (!study.client_id || study.paid) return null;
  const toggle = async (v) => {
    try { const r = await api.put(`/studies/${study.id}`, { share_preview: v }); onChange(r.data); toast.success(v ? "Draft preview shared in the client portal" : "Draft preview hidden"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="no-print flex flex-wrap items-center gap-3 rounded-xl border border-slate-800 bg-slate-900/70 px-5 py-3" data-testid="share-preview">
      <Eye className="h-4 w-4 text-amber-400" />
      <span className="text-sm text-slate-300 flex-1">Share draft preview<span className="block text-xs text-slate-500">Before payment, the client sees the score, verdict, executive summary and market size. The rest stays locked, with a DRAFT watermark and no downloads.</span></span>
      <Switch data-testid="share-preview-switch" checked={!!study.share_preview} onCheckedChange={toggle} />
    </div>
  );
};
